import { UsersReportFilters, usersService } from '@/services';
import {
  downloadBlob,
  filenameFromResponse,
} from '@/shared/utils/download-blob.util';
import { useMutation } from '@tanstack/react-query';

/** Exporta o relatório de usuários (todos os registros do filtro) para Excel e dispara o download. */
export function useUsersReportExport() {
  return useMutation({
    mutationFn: async (filters: UsersReportFilters) => {
      const response = await usersService.exportUsersReport(filters);
      if (!response.ok) {
        throw new Error(
          'Não foi possível exportar o relatório de usuários no momento. Tente novamente mais tarde.'
        );
      }
      const blob = await response.blob();
      const today = new Date().toLocaleDateString('en-CA');
      const filename = filenameFromResponse(
        response,
        `relatorio-usuarios-${today}.xlsx`
      );
      downloadBlob(blob, filename);
      return filename;
    },
  });
}
